<template>
    <!-- 外框   -->
    <div class="btn-border" :style="colorStyle" @click="onClick">
        <div class="btn-text">
            <span></span>
            <span>
            <!-- 文字 -->
            <slot></slot>
        </span>
        </div>
    </div>
</template>

<script>
    import log from "utils/log"

    export default {
        name: 'mobile-button',
        props: {
            color: String,
            icon: String,
            borderColor: String,
        },
        data() {
            return {}
        },
        computed: {
            colorStyle() {
                let bc = this.borderColor ? this.borderColor: this.color

                return {
                    color: this.color,
                    'border-color': bc,
                }
            },
        },
        methods: {
            onClick() {
                this.$emit('click')
            }
        },
        created() {
        },
        mounted() {
        }
    }
</script>

<style lang='scss' scoped>
    .btn-border {
        border: 1px solid #000000;
        color: #000000;
        border-radius: 10px;
    }

    .btn-text {
        /*mar*/
        padding: 5px;
    }



</style>
